import { createAction } from '@reduxjs/toolkit';
import { OpenFastCheckoutAction } from 'reactApp/modules/payment/payment.types';

export const openFastCheckout = createAction<OpenFastCheckoutAction>('payment/openFastCheckout');
